module.exports = __webpack_public_path__ + "img/de8b2e38e1eae3c98861ce3cc5990079.png";